import produce, { original } from 'immer';

import { I13N_CATEGORY_APP, I13N_TYPE_TIMING } from 'Lib/constants/i13nSpec';
import getI13nUtils from 'Lib/i13n/getI13nUtils';
import type { Action } from 'Lib/reduxType';
import { cleanPath, stripID } from 'Lib/utils/pathUtils';

import { ROUTE_NAVIGATE, SET_ROUTE_END, SET_ROUTE_INFO } from './constants';
import initialState from './initialState';
import type { RoutingState } from './types';

const { executeEvent } = getI13nUtils();

export const reducer = produce<RoutingState, [Action]>((draft, action) => {
  switch (action.type) {
    case SET_ROUTE_INFO: {
      const { path, params, location = {} } = action.payload;
      const { hash, search, pathname, state: routeState } = location;
      // on top
      draft.prevPath = original(draft)?.currentPath;

      draft.currentPath = cleanPath(path);
      draft.hash = hash;
      draft.navigate = undefined;
      draft.navigateStart = Date.now();
      draft.params = params;
      draft.pathname = pathname;
      draft.routeState = routeState;
      draft.search = search;

      break;
    }
    case SET_ROUTE_END: {
      const { currentPath = '/', navigateStart } = draft;
      if (navigateStart) {
        const navigateDuration = Date.now() - navigateStart;
        executeEvent(I13N_TYPE_TIMING, {
          event_category: I13N_CATEGORY_APP,
          name: `Navigation - ${stripID(currentPath)}`,
          value: navigateDuration,
        });

        draft.navigateDuration = navigateDuration;
      }
      draft.navigate = undefined;
      break;
    }
    case ROUTE_NAVIGATE: {
      const { path, state } = action.payload;
      if (path && !draft.navigate && path !== draft.currentPath) {
        draft.navigate = {
          path,
          state,
        };
      }
      break;
    }
    default:
      break;
  }
}, initialState);
